/**
 * Helper function to find matches in the array of objects or strings
 * @param {String} value
 *   Value to search.
 * @param {Array} list
 *   List of object or string where to search.
 * @param {String} objectKey
 *   Key of the object to compare with.
 * @returns {boolean}
 *   True in case given value exists in the array.
 */
const hasMatch = (value, list, objectKey = '') => {
  let compValue;
  for (let i = 0; i < list.length; i += 1) {
    compValue = objectKey ? list[i][objectKey] : list[i];
    if (compValue.toLowerCase() === value.toLowerCase()) {
      return true;
    }
  }
  return false;
};

export default hasMatch;
